// extracted by mini-css-extract-plugin
module.exports = {"ContactLink":"ContactLink_ContactLink__1kW9P","ContactLink__Image":"ContactLink_ContactLink__Image__3O24f","ContactLink__Name":"ContactLink_ContactLink__Name__2LBR4"};